import { $vars } from '../../../config/vars';
import { yLoadAsyncScript } from '../../y/util';
import { $ui } from '../functions';

export namespace $facebook {
    let facebook_loaded = false;
    let facebook_promise: Promise<void> | undefined;

    export function init() {
        if(!facebook_promise) {
            facebook_promise = yLoadAsyncScript('//connect.facebook.net/en_US/sdk.js', 'fbAsyncInit').then(() => {
                FB.init({
                    appId: $vars.facebook_app_id,
                    version: 'v3.0'
                });
                facebook_loaded = true;
            });
        }

        return facebook_promise;
    }

    export function share(url: string, hashtag?: string) {
        if(facebook_loaded && $vars.facebook_domains.includes(window.location.hostname)) {
            FB.ui({ method: 'share', href: url, hashtag: hashtag }, () => {
                // TODO: see if we can really find out if it was shared
            });
        } else {
            $ui.openWindow('https://www.facebook.com/sharer.php?u=' + encodeURIComponent(url), { width: 600, height: 400 });
        }
    }
}